import { render, staticRenderFns } from "./transports.vue?vue&type=template&id=5342b84b&"
import script from "./transports.vue?vue&type=script&lang=js&"
export * from "./transports.vue?vue&type=script&lang=js&"
import style0 from "./transports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports